/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Rushaki 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Gitega": ["Bugwe", "Gisiza", "Gitega", "Kabo", "Karambi", "Karambo", "Rubyiro", "Ryaruganzu"],
  "Kamutora": ["Gashinge", "Kabuga", "Kamutora", "Karwoga", "Mabare", "Nkamba", "Nyamyumba", "Remera"],
  "Karurama": ["C. Rushaki", "Gatonde", "Izinga", "Mbuga", "Ngabira", "Nyaruhanga", "Rumuri", "Rwaranda"]
};